import React, { useState } from 'react';
import './Contact.css';
import { API_ENDPOINTS } from '../../config/api';

const Contact = ({ t }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    numberOfPeople: '',
    travelDate: '',
    tour: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(API_ENDPOINTS.CONTACT_SUBMIT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (data.success) {
        alert(t.form.success);
        setFormData({ name: '', email: '', phone: '', numberOfPeople: '', travelDate: '', tour: '', message: '' });
      } else {
        alert('Error: ' + (data.message || 'Unable to submit form. Please try again.'));
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Connection error. Please verify that the server is running and try again later.');
    }
  };

  return (
    <section id="contact" className="contact">
      <div className="container">
        <div className="section-header">
          <span className="section-tag">{t.tag}</span>
          <h2>{t.title}</h2>
        </div>
        <div className="contact-content">
          <div className="contact-info">
            <div className="contact-item">
              <i className="fas fa-map-marker-alt"></i>
              <div>
                <h4>{t.address}</h4>
                <p>{t.addressText}</p>
              </div>
            </div>
            <div className="contact-item">
              <i className="fas fa-phone"></i>
              <div>
                <h4>{t.phone}</h4>
                <p>+221 77 777 77 77</p>
              </div>
            </div>
            <div className="contact-item">
              <i className="fas fa-envelope"></i>
              <div>
                <h4>{t.email}</h4>
                <p>contact@smilingsn.com</p>
              </div>
            </div>
          </div>
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="name">{t.form.name} *</label>
                <input
                  id="name"
                  type="text"
                  name="name"
                  placeholder={t.form.name}
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">{t.form.email} *</label>
                <input
                  id="email"
                  type="email"
                  name="email"
                  placeholder={t.form.email}
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="phone">{t.form.phone}</label>
                <input
                  id="phone"
                  type="tel"
                  name="phone"
                  placeholder={t.form.phone}
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label htmlFor="numberOfPeople">{t.form.numberOfPeople}</label>
                <input
                  id="numberOfPeople"
                  type="number"
                  name="numberOfPeople"
                  placeholder={t.form.numberOfPeople}
                  value={formData.numberOfPeople}
                  onChange={handleChange}
                  min="1"
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="travelDate">{t.form.travelDate}</label>
                <input
                  id="travelDate"
                  type="date"
                  name="travelDate"
                  value={formData.travelDate}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label htmlFor="tour">{t.form.selectTour}</label>
                <select
                  id="tour"
                  name="tour"
                  value={formData.tour}
                  onChange={handleChange}
                  className="form-select"
                >
                  <option value="">{t.form.selectTour}</option>
                  <option value="goree">Île de Gorée / Goree Island</option>
                  <option value="pink-lake">Lac Rose / Pink Lake</option>
                  <option value="sine-saloum">Delta du Sine Saloum / Sine Saloum Delta</option>
                  <option value="bandia">Réserve de Bandia / Bandia Reserve</option>
                  <option value="saint-louis">Saint-Louis</option>
                  <option value="dakar">Tour de Dakar / Dakar Tour</option>
                  <option value="bassari">Pays Bassari / Bassari Country</option>
                  <option value="casamance">Casamance</option>
                  <option value="lompoul">Désert de Lompoul / Lompoul Desert</option>
                  <option value="gambia">La Gambie / The Gambia</option>
                </select>
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="message">{t.form.message} *</label>
              <textarea
                id="message"
                name="message"
                placeholder={t.form.message}
                rows="5"
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
            </div>

            <button type="submit" className="btn-primary large">{t.form.send}</button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
